import { useState } from 'react'

import { Box, Button, Icon, Modal, Popover } from '@fairfashion/design-system'
import Parser from 'html-react-parser'
import { useNavigate } from 'react-router-dom'

import * as Styles from './dashboard-card-menu.styles'
import { DashboardCardMenuProps } from './dashboard-card-menu.types'

export const DashboardCardMenu = ({
  title,
  details,
  url,
}: DashboardCardMenuProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement>()
  const [detailsModalOpen, setDetailsModalOpen] = useState(false)

  const handleOpenDetails = () => {
    setDetailsModalOpen(true)
    setAnchorEl(undefined)
  }

  const navigate = useNavigate()

  const handleGoToPage = () => {
    setDetailsModalOpen(false)
    navigate(url!)
  }

  const showMenu = !!url || !!details

  return (
    <>
      {showMenu && (
        <Styles.Container onClick={(e) => setAnchorEl(e.currentTarget)}>
          <Button variant="text" padding="0">
            <Icon name="more" color="grey_3" size={20} />
          </Button>
        </Styles.Container>
      )}
      <Popover
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(undefined)}
        borderRadius="8px"
        position="bottom-start"
        offset={0}
      >
        <Box padding={0} direction="column">
          {details && (
            <Styles.MenuOption onClick={handleOpenDetails}>
              <Icon name="information" color="grey_1" size={16} />
              Detalhes
            </Styles.MenuOption>
          )}
          {url && (
            <a href={url}>
              <Styles.MenuOption>
                <Icon name="arrow_right_up" color="grey_1" size={16} />
                Ver mais sobre
              </Styles.MenuOption>
            </a>
          )}
        </Box>
      </Popover>
      <Modal
        open={detailsModalOpen}
        onClose={() => setDetailsModalOpen(false)}
        title={title}
        width="600px"
        maxWidth="90%"
      >
        <Box direction="column" gap={3} width="100%">
          <Box paddingTop={1} width="100%">
            <Styles.DetailsText>
              {details ? Parser(details) : ''}
            </Styles.DetailsText>
          </Box>

          <Box width="100%" justifyContent="flex-end" gap={1}>
            <Button
              variant="outlined"
              onClick={() => setDetailsModalOpen(false)}
            >
              Fechar
            </Button>
            {url && (
              <Button variant="contained" onClick={handleGoToPage}>
                Ir para página
              </Button>
            )}
          </Box>
        </Box>
      </Modal>
    </>
  )
}
